import { BaseService } from '../base/BaseService';

export type ProjectProductReference = {
  projectId: string;
  productId: string;
  position: number;
  title: string;
  imageUrl?: string;
};

export class ProjectProductReferenceService extends BaseService {
  async list(projectId: string): Promise<ProjectProductReference[]> {
    const { data, error } = await this.client
      .from('project_product_refs')
      .select('project_id, product_id, position, shopify_products(title, images)')
      .eq('project_id', projectId)
      .order('position');
    if (error) throw error;
    return (data ?? []).map((row) => {
      const relation = row.shopify_products as unknown;
      const product = (Array.isArray(relation) ? relation[0] : relation) as {
        title?: string;
        images?: Array<{ url?: string }>;
      } | null;
      return {
        projectId: row.project_id,
        productId: row.product_id,
        position: row.position,
        title: product?.title ?? 'Unavailable product',
        imageUrl: product?.images?.[0]?.url,
      };
    });
  }

  async replace(projectId: string, productIds: string[]): Promise<void> {
    const { error } = await this.client.rpc('replace_project_product_refs', {
      p_project_id: projectId,
      p_product_ids: productIds,
    });
    if (error) throw error;
  }
}

export const projectProductReferenceService = new ProjectProductReferenceService();
